import  { createContext } from 'react'

export const PackageContext = createContext(null);
